import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AllotmentListDataService extends DataService<typeof Model.Products.Logic.ViewModels.AllotmentSummary, Model.Products.Logic.ViewModels.AllotmentSummary, AllotmentSummary> {
    protected map(entity: Model.Products.Logic.ViewModels.AllotmentSummary): AllotmentSummary {
        return new AllotmentSummaryModel(entity);
    }

    static make(context?: any): AllotmentListDataService {
        return new AllotmentListDataService(context, ctx => ctx.AllotmentSummaries);
    }
}

export class AllotmentSummaryModel extends EntityModel<Model.Products.Logic.ViewModels.AllotmentSummary, AllotmentSummary> implements AllotmentSummary {
    @property<AllotmentSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<AllotmentSummaryModel>(o => o.entity.name, (o, value) => o.entity.name = value)
    public name: string;

    @property<AllotmentSummaryModel>(o => o.entity.parentAllotmentId, (o, value) => o.entity.parentAllotmentId = value)
    public parentAllotmentId?: number;

    @property<AllotmentSummaryModel>(o => o.entity.hasChildren, (o, value) => o.entity.hasChildren = value)
    public hasChildren: boolean;

    @property<AllotmentSummaryModel>(o => o.entity.hasContracts, (o, value) => o.entity.hasContracts = value)
    public hasContracts: boolean;
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/list/allotment-list.data.ts